import { TOOLTIP_MAX_WIDTH, type HotspotMarkerData } from '@guidde/design-system'

import { type HotspotShapeType } from 'app/types'

// Maps the stored hotspot layer (embed model) onto the presentational marker props. Keeps the DS
// components free of the app model — the only place that knows both shapes.
export const toHotspotMarker = (layer: HotspotShapeType): HotspotMarkerData => ({
    id: layer.id,
    x: layer.x,
    y: layer.y,
    label: layer.label,
    fillColor: layer.fillColor,
    textColor: layer.textColor,
    tooltipPosition: layer.tooltipPosition,
    isOpenByDefault: layer.openByDefault,
    tooltipWidth: layer.width || TOOLTIP_MAX_WIDTH,
})
